import {
  DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates, arrayMove } from '@dnd-kit/sortable';
import { PageElement } from '@holloway/dsl';

interface UseElementDragAndDropProps {
  elements: PageElement[];
  onReorder: (elements: PageElement[]) => void;
}

export function useElementDragAndDrop({ elements, onReorder }: UseElementDragAndDropProps) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = elements.findIndex((el) => el.id === active.id);
      const newIndex = elements.findIndex((el) => el.id === over.id);

      onReorder(arrayMove(elements, oldIndex, newIndex));
    }
  };

  return {
    sensors,
    handleDragEnd,
  };
}
